
  import commonUtils from '~/mixins/pages/mission-control/commonUtils'
  import vipSettings from '~/mixins/pages/mission-control/vipSettings'
  export default {
    name: 'Theme2MissionVipTierStatus',
    mixins: [vipSettings, commonUtils],
    props: {
      displayTierTitle: {
        type: Boolean,
        default: false
      },
      width: {
        type: String,
        default: '350px'
      }
    },
    computed: {
      tiersList() {
        if (this.vipTiers?.tiers?.length)
          return this.vipTiers.tiers?.filter(el => el.tier_type === 1)
        return []
      }
    }
  }
